import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { BenefitSummaryList } from "src/app/models/benefit-summary";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-summary',
    templateUrl: './summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutSummaryComponent implements OnInit {
    @Input() public benefitSummaryList: BenefitSummaryList;
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public totalAmount: number;

    constructor(
    ) {
    }

    ngOnInit(): void {
        this.totalAmount = this.benefitSummaryList.summaryTotalCards.reduce((sum, stc) => (sum + stc.totalCost), 0);
    }

    public complete(): void {
        this.emitComplete.emit();
    }

    public updateFiles(): void {
    }
}